<template>
  <div v-if="false" class="top-bar">
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import store from '@/store'

export default {
  computed: {
    ...mapGetters(['userInfo'])
  },
  data () {
    return {
      isManager: false
    }
  },
  mounted () {
    this.currentUserId = store.state.user.userInfo.id;
  },
  methods: {
        handleCommand (key) {
       switch (key) {
         case 'logout':
          this.$store.commit('removeUserInfo')
          this.$router.push({ name: 'login' })
         break
         case 'dashboard':
          // this.$router.push({ name: 'dashboard' })
          window.location.href = 'http://36.133.16.107:8082/system/#/';
         break
         case 'password':
          this.$refs.PasswordChangeDialog.open();
          break;
       }
    }
  }
}
</script>

<style scoped lang="less">
 @import '~@/styles/variables.less';
.top-bar {
  width: 100%;
  height: 70 * @uh;
  // background-color: #ccc;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgb(44, 105, 128);

  .title {
    font-size: 25 * @uw;
    margin-left: 10 * @uw;
    color: white;
  }
  .dropdown {
    margin-right: 26 * @uw;
  }
  /deep/ .el-avatar {
    background-color: rgba(0, 0, 0, 0);
  }
}
</style>
